import * as React from 'react'

function IconInstagram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={45}
      height={45}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.212 10.49a2.703 2.703 0 10-5.405 0 2.702 2.702 0 005.405 0z"
        fill="#C4C4C4"
      />
      <path
        d="M40.812 31.591c-.1 2.194-.467 3.386-.772 4.178-.409 1.05-.897 1.8-1.689 2.587-.783.788-1.533 1.274-2.583 1.68-.792.308-1.988.677-4.182.782-2.372.104-3.075.126-9.089.126-6.01 0-6.717-.022-9.089-.127-2.194-.104-3.385-.472-4.176-.782-1.056-.405-1.801-.891-2.588-1.679-.793-.787-1.281-1.538-1.685-2.587-.305-.792-.678-1.984-.772-4.178-.116-2.372-.137-3.086-.137-9.088 0-6.014.021-6.723.137-9.095.094-2.194.467-3.385.772-4.183.403-1.049.892-1.795 1.685-2.582.787-.786 1.532-1.274 2.588-1.683.791-.31 1.982-.673 4.176-.778 2.372-.104 3.08-.131 9.089-.131 6.014 0 6.717.027 9.089.131 2.194.105 3.39.468 4.182.778 1.05.409 1.8.897 2.583 1.683.792.787 1.28 1.533 1.69 2.582.304.798.671 1.99.771 4.183.11 2.372.137 3.08.137 9.095 0 6.002-.026 6.716-.137 9.088zm4.051-18.368c-.11-2.397-.488-4.035-1.05-5.461-.57-1.48-1.337-2.735-2.591-3.989-1.25-1.248-2.504-2.015-3.984-2.593C35.806.624 34.174.241 31.776.137 29.377.02 28.61 0 22.497 0c-6.108 0-6.88.021-9.278.137C10.826.24 9.195.624 7.756 1.18c-1.475.578-2.729 1.344-3.978 2.592-1.253 1.255-2.02 2.51-2.597 3.99-.556 1.426-.934 3.064-1.05 5.461C.027 15.623 0 16.39 0 22.503c0 6.108.027 6.874.13 9.273.116 2.393.494 4.03 1.05 5.463.578 1.475 1.344 2.735 2.598 3.983 1.25 1.25 2.504 2.021 3.978 2.598 1.438.556 3.07.934 5.463 1.044 2.399.11 3.17.137 9.278.137 6.114 0 6.88-.027 9.278-.137 2.398-.11 4.03-.488 5.463-1.044 1.48-.577 2.735-1.349 3.984-2.598 1.254-1.248 2.02-2.508 2.592-3.983.56-1.433.94-3.07 1.05-5.463.109-2.399.136-3.165.136-9.273 0-6.114-.026-6.88-.137-9.28z"
        fill="#C4C4C4"
      />
      <path
        d="M22.497 29.996c-4.14 0-7.5-3.354-7.5-7.493a7.502 7.502 0 1115.005 0c0 4.14-3.364 7.493-7.505 7.493zm0-19.054c-6.381 0-11.55 5.18-11.55 11.561 0 6.376 5.168 11.55 11.55 11.55 6.382 0 11.555-5.174 11.555-11.55.001-6.381-5.173-11.561-11.555-11.561z"
        fill="#C4C4C4"
      />
    </svg>
  )
}

export default IconInstagram
